import React from 'react';
import { Card, Grid, Typography, Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import RemarksEditor from '../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor';

const PfarRemarks = ({
    title,
    name,
    defaultValue,
    extraLabel,
    setDeveloperRemarks,
    developerRemarks,
    buttonshow = false,
    onSaveClick,
    error,
    setError
}) => {
    const {
        control,
        getValues,
    } =  useForm()

    const handleClick = () => {
        onSaveClick(developerRemarks); // ✅ Pass both values
    };


    return (
        <Card sx={{ backgroundColor: "#f9f9f9", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", my: 2, p: 2 }}>
            <Typography
                variant="h6"
                sx={{
                    background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
                    p: 1,
                    color: "#fff",
                    textAlign: "left",
                    borderRadius: "4px",
                    fontSize: '1rem',
                    padding: '10px',
                    fontFamily: 'sans-serif',
                    lineHeight: '1.5'
                }}
            >
                {title}
            </Typography>
            <Grid container spacing={1} sx={{ my: 2 }}>
                <Grid item xs={3}>
                    <Typography>{extraLabel}<span style={{ color: 'red' }}> *</span></Typography>
                </Grid>
                <Grid item xs={8}>
                    <RemarksEditor setRemarks={setDeveloperRemarks} remarks={developerRemarks} error={error} setError={setError} />
                </Grid>
            </Grid>
            {buttonshow && (
                <div style={{ textAlign: "center", marginTop: "24px" }}>
                    <Button variant="contained" color="secondary" onClick={handleClick} style={{ margin: "auto", height: "30px", width: "10%", borderRadius: "4px", backgroundColor: '#157CB3' }}>
                        Save
                    </Button>
                </div>)}
        </Card>
    );
};

export default PfarRemarks;


